<template>
  <BoardLayout>
    <template #[templateId]>
      <WidgetWrapper
        v-if="board?.layout && widget?.resourcetype"
        :key="board.id"
        :type="board.layout"
        :color="board.widgets[0]?.bg_color"
        :name="widget?.resourcetype"
      >
        <Component :is="widgetComponent" v-if="widget" :widget="widget" />
      </WidgetWrapper>
    </template>
  </BoardLayout>
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent, onBeforeMount } from 'vue'

import BoardLayout from '@/components/BoardLayout.vue'
import WidgetWrapper from '@/components/WidgetWrapper.vue'
import { useBoardStore } from '@/stores/useBoardStore'
import { useContentManagerStore } from '@/stores/useContentManagerStore'

const lazyImportedWidgets = import.meta.glob('../components/widgets/*.vue')

const boardStore = useBoardStore()
const board = computed(() => boardStore.board)
const widget = computed(() => boardStore.board?.widgets[0])
const widgetComponent = computed(
  () =>
    widget.value &&
    defineAsyncComponent(
      // @ts-ignore
      lazyImportedWidgets?.[
        `../components/widgets/${widget.value.resourcetype}.vue`
      ]
    )
)
const templateId = computed(() => board.value?.layout ?? 'square')
const manager = useContentManagerStore()

onBeforeMount(() => manager.bootstrapContentManager())
</script>
<style lang="scss" scoped></style>
